import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PaginatedList } from '../api/api-response';
import { LogAuditoria, AuditoriaFiltro } from './auditoria.model';

@Injectable({ providedIn: 'root' })
export class AuditoriaService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Auditoria`;

  consultar(filtro: AuditoriaFiltro): Observable<ApiResponse<PaginatedList<LogAuditoria>>> {
    const params: Record<string, string> = {};
    for (const [k, v] of Object.entries(filtro)) {
      if (v !== undefined && v !== null && v !== '') params[k] = String(v);
    }
    return this.http.get<ApiResponse<PaginatedList<LogAuditoria>>>(this.url, { params });
  }
}
